import { render, staticRenderFns } from "./DeployedContracts.vue?vue&type=template&id=2825df88&scoped=true&"
import script from "./DeployedContracts.vue?vue&type=script&lang=js&"
export * from "./DeployedContracts.vue?vue&type=script&lang=js&"
import style0 from "./DeployedContracts.vue?vue&type=style&index=0&id=2825df88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2825df88",
  null
  
)

export default component.exports